import React from 'react';
import { Row, Col, Image } from 'antd';
import logo from '../../image/logo.svg';
import { HEADER_TEXTS } from '../helpers/misc';

const Header = () => {
  return (
    <Row justify="center" className="logo-container">
      <Col>
        <a href="https://vernost.benulekaren.sk/" rel="noopener noreferrer">
          <Image
            className="logo"
            src={logo}
            alt={HEADER_TEXTS.logoAlt}
            preview={false}
          />
        </a>
      </Col>
    </Row>
  );
};

export default Header;
